export default "__VITE_ASSET__COb3hFPf__"